import { app } from './app';

import Debounce from "../directives/debounce";

app.directive('debounce', Debounce);
